import { render, staticRenderFns } from "./ConsultaSapWebComponent.vue?vue&type=template&id=70cbb300"
import script from "./ConsultaSapWebComponent.vue?vue&type=script&lang=js"
export * from "./ConsultaSapWebComponent.vue?vue&type=script&lang=js"
import style0 from "./ConsultaSapWebComponent.vue?vue&type=style&index=0&id=70cbb300&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports